<template>
    <div style="display: flex; align-items: center; justify-content: flex-end;">
        <div v-if="tag">
            <v-chip 
                v-if="tag === 'min' || tag === 'same'"
                class="mr-2 mb-1"
                color="rgba(217, 108, 188, 0.2)"
                label
                style="display: block;"
                :key="`min-${sensorKey}-${index}`"
            >
                <v-icon color="#D96CBC">mdi-arrow-down</v-icon>
                <span style="color: #D96CBC">Menor {{sensorDescription}} no período</span>
            </v-chip>
            <v-chip 
                v-if="tag === 'max' || tag === 'same'"
                class="mr-2"
                color="rgba(51, 156, 185, 0.2)"
                label
                style="display: block;"
                :key="`max-${sensorKey}-${index}`"
            >
                <v-icon color="#339CB9">mdi-arrow-up</v-icon>
                <span style="color: #339CB9">Maior {{sensorDescription}} no período</span>
            </v-chip>
        </div>
        <span :key="`span-${sensorKey}-${index}`">
            {{showNormalValue(item[`sensor${sensorKey}Value`])}}
        </span>
    </div>
</template>

<script>
import moment from "moment";
export default {
    name: "SummarySensorValueTable",
    props: ["type", "highlightsCards", "item", "sensorKey", "index"],
    data: () => ({
        tag: undefined,
        sensorDescription: undefined,
    }),

    created(){
        this.initialize();
    },

    watch:{
        item(value){
            if(value){
                this.initialize();
            }
        },
        highlightsCards(value){
            if(value){
                this.initialize();
            }
        }
    },

    methods:{
        initialize(){
            const findResult = this.itemHasTag(this.item.dateIso, this.item[`sensor${this.sensorKey}Id`]);
            if(findResult){
                const { tag, sensor } = findResult;
                this.tag = tag;
                this.sensorDescription = sensor.descricao;
            }else{
                this.tag = undefined;
                this.sensorDescription = undefined;
            }
        },

        itemHasTag(itemDate, itemSensorId){
            const stringIsoFormat = this.type === "mensal" ? "YYYY-MM" : "YYYY-MM-DD";
            const date = moment(itemDate, stringIsoFormat);
            if(this.type === "mensal"){
                const findResult = this.highlightsCards.find((result) => {
                    const { ano, mes, tag, sensorId } = result;
                    return moment(`${ano}-${mes}`, stringIsoFormat).isSame(date, "months") && itemSensorId == sensorId && tag;
                });
                return findResult;
            }
            if(this.type === "diario"){
                const findResult = this.highlightsCards.find((result) => {
                    const { data, tag, sensorId } = result;
                    return moment(data, stringIsoFormat).isSame(date, "day") && itemSensorId == sensorId && tag;
                });
                return findResult;
            }
            return undefined;
        },

        showNormalValue(value){
            return value ? value : value === 0 ? Number(value).toFixed(1) :  "--";
        }
    }
}
</script>

<style>

</style>